import { ExpandableAreaProvider } from '@makemydeal/dr-dash-components';
import { OUTSIDE_LIENHOLDER_HEADER_NAME } from './constants';
import { OutsideLienholderToggleHeader } from './OutsideLienholderToggleHeader.interstate';
import OutsideLienholderExpandableSection from './OutsideLienholderExpandableSection.interstate';

const OutsideLienholder = () => {
    return (
        <ExpandableAreaProvider>
            <OutsideLienholderToggleHeader expandableId={OUTSIDE_LIENHOLDER_HEADER_NAME} />
            <OutsideLienholderExpandableSection />
        </ExpandableAreaProvider>
    );
};

export default OutsideLienholder;
